<script setup>
import {ref, inject, onBeforeMount, computed} from "vue"

import ProgressSpinner from "primevue/progressspinner"
import Button from 'primevue/button'
import { ZoomImg } from "vue3-zoomer";

import {useMain} from "@/stores/main"

const mainStore = useMain()

const dialogRef = inject('dialogRef', null)

const props = defineProps({
    trainee: {
        type: Object,
    },
    item: {
        type: Object,
    },

})

// const emit = defineEmits(['updated'])

const $item = ref(null)

const $loading = ref(true)
const $trainee = ref(null)

/*const closeDialog = () => {
    if (dialogRef.value) dialogRef.value.close($trainee)
}*/

const uri = computed(() => {
    return import.meta.env.VITE_APP_PUBLIC_BACKEND_URL + '/api/trainees/' + $trainee.value.id + '/document/view/' + $item.value.id + '/' + $item.value.path.split('/').reverse()[0]
})

onBeforeMount(async () => {
    await mainStore.loadTraineeDocumentsTypes(true)
    if (dialogRef.value.data) {
        $item.value = dialogRef.value.data.item
        $trainee.value = dialogRef.value.data.trainee
    } else {
        $item.value = props.item
        $trainee.value = props.trainee
    }

    $loading.value = false
})
</script>
<template>
    <div v-if="$loading" class="text-center">
        <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5"></ProgressSpinner>
    </div>
    <div v-else-if="$item.mime_type === 'application/pdf'" class="h-full">
        <iframe :src="uri" class="w-full h-full"></iframe>
    </div>
    <div v-else-if="$item.mime_type.startsWith('image')" class="text-center h-full f">
        <ZoomImg
            class=""
            zoom-type="drag"
            :src="uri"
            :zoom-scale="8"
            :step="1"
            :show-zoom-btns="true"
        />
    </div>
    <div v-else>
        <Button icon="mdi mdi-login" label="Téléchargert"/>
    </div>
</template>
